import {Component, ElementRef, EventEmitter, Input, OnInit, Output, AfterViewInit} from '@angular/core';

@Component({
  selector: 'aux-digit-code',
  templateUrl: './digit-code.component.html',
  styleUrls: ['./digit-code.component.scss']
})
export class DigitCodeComponent implements OnInit, AfterViewInit {
  @Input() amount = 4; // default
  @Input() disabled = false;
  readonly classPrefixForInputFields = 'cCx-i';
  readonly idPrefixForInputFields = 'iXx-i';
  @Output() applyingCode: EventEmitter<string> = new EventEmitter<string>();
  codeParams: any[] = [];
  constructor(private elementRef: ElementRef) {
  }
  ngOnInit(): void {
    this.clearCode(false);
  }
  public get accessCode(): string {
    return this.codeParams.join('').trim();
  }

  clearCode(shouldFocus = true): void {
    this.codeParams = Array(this.amount).fill('');
    if (shouldFocus) {
      setTimeout(() => this.focusInput(0));
    }
  }

  onKeyUp(event: any, index: number, last: boolean): void {
    const key = event.keyCode || event.charCode;
    if (key === 8 || key === 46 ||    // backspace or delete
      (key === 8 && 17) ||          // backspace + ctrl
      (key === 8 && 16) ||          // backspace + shift
      (key === 46 && 17))     // delete + ctrl
    {
      return;
    }
    // console.log({index, event});
    if (!last) {
      const nextIndex = index + 1;
      if (this.codeParams.slice(0, nextIndex).join('').length === nextIndex) {
        this.codeParams[nextIndex] = '';
        this.focusInput(nextIndex);
      }
    }else {
      if (this.accessCode.length === this.amount) {
        this.applyingCode.emit(this.accessCode);
      }
    }
  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement | null;
    const value = String(input?.value || '');
    if (value.length <= 1) {
      return;
    }
    this.applyDigits(value, index);
  }

  onPaste(event: ClipboardEvent, index: number): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    this.applyDigits(pastedText, index);
  }

  trackByFn(index: number, item: any): number {
    return index;
  }

  ngAfterViewInit(): void {
    this.focusInput(0);
  }

  private focusInput(index: number): void {
    const input = this.elementRef.nativeElement
      .querySelector(`.${this.classPrefixForInputFields}${index}`);
    if (input) {
      (input as HTMLElement).focus();
    }
  }

  private applyDigits(rawValue: string, startIndex: number): void {
    const digits = String(rawValue || '').replace(/\D/g, '');
    if (!digits) {
      this.codeParams[startIndex] = '';
      return;
    }
    const nextCodeParams = [...this.codeParams];
    for (let offset = 0; offset < digits.length && startIndex + offset < this.amount; offset += 1) {
      nextCodeParams[startIndex + offset] = digits[offset];
    }
    this.codeParams = nextCodeParams;
    const nextIndex = Math.min(startIndex + digits.length, this.amount - 1);
    if (this.accessCode.length === this.amount) {
      this.applyingCode.emit(this.accessCode);
      return;
    }
    this.focusInput(nextIndex);
  }
}
